(() => {
  function init() {
    document.querySelectorAll('section.collection__list-section').forEach(sec => {
      if (sec.dataset.collectionsDeskBound === '1') return;
      sec.dataset.collectionsDeskBound = '1';

      const container = sec.querySelector('.collection__list-container');
      const prev = sec.querySelector('.collections-desk-prev');
      const next = sec.querySelector('.collections-desk-next');
      if (!container || !prev || !next) return;

      const step = () => {
        const item = container.querySelector('.collection__grid--item');
        return item ? Math.round(item.getBoundingClientRect().width) : Math.round(container.clientWidth);
      };

      const updateArrows = () => {
        const maxScroll = container.scrollWidth - container.clientWidth;

        // Si no hay overflow, ocultar ambas
        if (maxScroll <= 1) {
          prev.style.display = 'none';
          next.style.display = 'none';
          return;
        }

        // umbral para evitar “parpadeo” por decimales
        const epsilon = 2;
        const atStart = container.scrollLeft <= epsilon;
        const atEnd = container.scrollLeft >= (maxScroll - epsilon);

        prev.style.display = atStart ? 'none' : '';
        next.style.display = atEnd ? 'none' : '';
      };

      prev.addEventListener('click', (e) => {
        e.preventDefault();
        container.scrollLeft -= step();
        // update después del movimiento
        setTimeout(updateArrows, 50);
      });

      next.addEventListener('click', (e) => {
        e.preventDefault();
        container.scrollLeft += step();
        setTimeout(updateArrows, 50);
      });

      // cuando el usuario hace scroll/trackpad
      container.addEventListener('scroll', () => {
        // throttle ligero con rAF
        window.requestAnimationFrame(updateArrows);
      });

      // al cargar y al redimensionar
      updateArrows();
      window.addEventListener('resize', updateArrows);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();